import { createQuery } from '@tanstack/svelte-query';
import { fetchProductTypes, fetchCategories, fetchProducts } from '$lib/api/product';
import type { CategoryResponse, ProductResponse, ProductTypeResponse } from '$lib/types/product';

export const productsQuery = () =>
	createQuery<Array<ProductResponse>>(() => ({
		queryKey: ['products'],
		queryFn: () => fetchProducts()
	}));

export const productTypesQuery = () =>
	createQuery<Array<ProductTypeResponse>>(() => ({
		queryKey: ['product_types'],
		queryFn: () => fetchProductTypes()
	}));

export const categoriesQuery = () =>
	createQuery<Array<CategoryResponse>>(() => ({
		queryKey: ['categories'],
		queryFn: () => fetchCategories()
	}));
